import { CanActivateFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { UserStore } from '../store/user/user.store'

export const AuthGuard: CanActivateFn = (_route, _state) => {
  const userStore = inject(UserStore)
  const router = inject(Router)

  if (userStore.isAuthenticated()) {
    return true
  }

  return router.createUrlTree(['/login'])
}
